module.exports = __webpack_public_path__ + "img/report_blue.5ba1fa94.svg";